import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  const footerLinks = {
    about: [
      { label: t('footer.ourStory'), path: '/story' },
      { label: t('footer.community'), path: '/community' },
      { label: 'Success Stories', path: '/success-stories' },
      { label: 'Partners', path: '/partners' },
      { label: 'Crisis Tracker', path: '/crisis-tracker' },
    ],
    support: [
      { label: 'Donate', path: '/donate' },
      { label: 'Volunteer', path: '/volunteer' },
      { label: t('footer.shop'), path: '/shop' },
      { label: 'Resources', path: '/resources' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/f3fa860f7945560b37b9908a35f9ad89/3de3393ce9d705a053d3bfe72c6fc171.png"
              alt="SheCan Logo"
              className="h-12 mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              A movement born from resilience, built for every woman who has ever been told "you can't."
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/weareshecan" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                aria-label="SheCan Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/yarence_vik" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                aria-label="Founder Instagram"
              >
                <i className="ri-user-heart-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-gray-900">{t('common:footer.quickLinks')}</h3>
            <ul className="space-y-2">
              {/* All links removed as requested */}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">{t('contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-red-400 mt-1"></i>
                <a 
                  href="mailto:weareshecan@gmail.com" 
                  className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer"
                >
                  weareshecan@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
